import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {t} from 'shared/core';
import _ from 'lodash';

class ReportColumn extends DomainObject {
  key;
  order;
  name;

  constructor(other) {
    super();

    makeObservable(this, {
      key: observable,
      order: observable,
      name: observable,
      group: computed,
      translatable: computed,
      view: computed,
      customFieldId: computed
    });

    this.merge(other);
  }

  get group() {
    return _.split(this.key, '.')[0];
  }

  get translatable() {
    return this.group !== 'custom_fields';
  }

  get view() {
    return this.translatable ? t(`reports.custom.edit.fields.${this.key}`) : this.name;
  }

  get customFieldId() {
    if (this.group !== 'custom_fields') return '';
    return _.split(this.key, '.')[1];
  }
}

export default ReportColumn;
